import React, { memo, useCallback, useEffect, useState } from "react";
import api from "APP_ROOT/api";
import StatsPanel from "MODULES/Admin/PartRankings/StatsPanel";
import { properCase } from "LIB/formatters/text";
import { Col, Row } from "react-bootstrap";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import DropDownItem from "../../shared/components/DropDown/DropDownItem";

function PartRankings({ sellableQty, filter }) {
  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState({});

  const performRequest = useCallback(
    () => {
      api.parts.rankingStats(sellableQty, filter).then(({ data }) => {
        setResults(data);
        setIsLoading(false);
      });
    },
    [sellableQty, filter]
  );

  useEffect(
    () => {
      performRequest();
    },
    [sellableQty, filter]
  );

  if (isLoading) return null;
  return (
    <div>
      <Row>
        <StatsPanel
          title={properCase("sold_in_12_months")}
          results={results.sold_in_12_months}
        />

        <StatsPanel
          title={properCase("sold_in_4_months")}
          results={results.sold_in_4_months}
        />
      </Row>
      <Row>
        <StatsPanel
          title={properCase("average_days_in_stock")}
          results={results.average_days_in_stock}
        />
        <StatsPanel
          title={properCase("average_oq_per_month")}
          results={results.average_oq_per_month}
        />
      </Row>
    </div>
  );
}

const Report = memo(() => {
  const [noSellableQty, setNoSellableQty] = useState(false);
  const [filter, setFilter] = useState(null);

  const filterTypes = [
    {
      label: "All",
      func: () => {
        setNoSellableQty(false);
        setFilter(null);
      }
    },
    {
      func: () => setNoSellableQty(true),
      label: "No Sellable Qty"
    },
    {
      label: "Rotables",
      func: () => setFilter("rotable")
    },
    {
      label: "Expendables",
      func: () => setFilter("expendable")
    },
    {
      label: "Tooling",
      func: () => setFilter("tooling")
    }
  ];

  return (
    <Col>
      <Row>
        <Col md={12}>
          <div className="page-header page-header-bar">
            <h1>
              <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
                <ActionDropDown
                  menuClass="dropdown-menu-right"
                  style={{ cursor: "pointer" }}
                  label="Filter"
                >
                  {filterTypes.map(report => (
                    <DropDownItem key={report.value} onClick={report.func}>
                      <span>
                        <span>{report.label}</span>
                      </span>
                    </DropDownItem>
                  ))}
                </ActionDropDown>
              </div>
              Part Rankings{" "}
              {noSellableQty && (
                <button
                  className="btn btn-xs btn-default"
                  onClick={() => setNoSellableQty(false)}
                >
                  No Sellable Qty <i className="fa fa-fw fa-close" />
                </button>
              )}
              {filter && (
                <button
                  className="btn btn-xs btn-default"
                  onClick={() => setFilter(null)}
                >
                  {properCase(filter)} <i className="fa fa-fw fa-close" />
                </button>
              )}
            </h1>
          </div>
        </Col>
      </Row>
      <Row>
        <PartRankings sellableQty={noSellableQty} filter={filter} />
      </Row>
    </Col>
  );
});

export default Report;



// WEBPACK FOOTER //
// ./app/modules/Admin/PartRankings/PartRankings.jsx